if (!customElements.get('legal-price-gauge')) {
  class LegalPriceGauge extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.rangeMin = this.querySelector('[data-gauge-range="min"]');
      this.rangeMax = this.querySelector('[data-gauge-range="max"]');
      const priceFields = this.querySelectorAll('price-range input[type="number"]');
      this.fieldMin = priceFields[0];
      this.fieldMax = priceFields[1];
      this.outputMin = this.querySelector('[data-gauge-output="min"]');
      this.outputMax = this.querySelector('[data-gauge-output="max"]');

      if (!this.rangeMin || !this.rangeMax || !this.fieldMin || !this.fieldMax) return;

      this.dataset.ready = 'true';
      this.maximum = Number(this.rangeMax.max) || 0;
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR',
        maximumFractionDigits: 0,
      });

      this.rangeMin.addEventListener('input', () => this.updateFromGauge('min'));
      this.rangeMax.addEventListener('input', () => this.updateFromGauge('max'));
      this.fieldMin.addEventListener('input', () => this.updateFromFields());
      this.fieldMax.addEventListener('input', () => this.updateFromFields());
      this.updateFromFields();
    }

    clampValues(source) {
      let minimum = Number(this.rangeMin.value);
      let maximum = Number(this.rangeMax.value);

      if (minimum > maximum) {
        if (source === 'min') maximum = minimum;
        else minimum = maximum;
      }

      this.rangeMin.value = minimum;
      this.rangeMax.value = maximum;
      return { minimum, maximum };
    }

    updateFromGauge(source) {
      const { minimum, maximum } = this.clampValues(source);
      this.fieldMin.value = minimum <= 0 ? '' : minimum;
      this.fieldMax.value = maximum >= this.maximum ? '' : maximum;
      this.paint(minimum, maximum);

      const changedField = source === 'min' ? this.fieldMin : this.fieldMax;
      changedField.dispatchEvent(new Event('input', { bubbles: true }));
    }

    updateFromFields() {
      this.rangeMin.value = this.fieldMin.value === '' ? 0 : Number(this.fieldMin.value);
      this.rangeMax.value = this.fieldMax.value === '' ? this.maximum : Number(this.fieldMax.value);
      const { minimum, maximum } = this.clampValues('max');
      this.paint(minimum, maximum);
    }

    paint(minimum, maximum) {
      const start = this.maximum > 0 ? (minimum / this.maximum) * 100 : 0;
      const end = this.maximum > 0 ? (maximum / this.maximum) * 100 : 100;
      const fill = this.querySelector('.legal-price-gauge__fill');

      if (fill) {
        fill.style.left = `${start}%`;
        fill.style.right = `${100 - end}%`;
      }
      if (this.outputMin) this.outputMin.textContent = this.formatter.format(minimum);
      if (this.outputMax) this.outputMax.textContent = this.formatter.format(maximum);
    }
  }

  customElements.define('legal-price-gauge', LegalPriceGauge);
}

// Keep the collection filters below the visible header without covering product cards.
(() => {
  const filters = document.querySelector('[data-legal-sticky-filters]');
  if (!filters || filters.dataset.legalStickyReady === 'true') return;

  const sentinel = filters.previousElementSibling;
  const header = document.querySelector('.section-header');
  filters.dataset.legalStickyReady = 'true';
  let frame = 0;

  const update = () => {
    frame = 0;
    if (!filters.isConnected) return;

    const headerBottom = header && !header.classList.contains('shopify-section-header-hidden')
      ? Math.max(0, Math.min(window.innerHeight, Math.ceil(header.getBoundingClientRect().bottom)))
      : 0;

    filters.style.setProperty('--legal-filters-sticky-top', `${headerBottom}px`);

    if (sentinel && sentinel.hasAttribute('data-legal-filters-sentinel')) {
      filters.classList.toggle('is-stuck', sentinel.getBoundingClientRect().top <= headerBottom + 1);
    }
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if (header && 'ResizeObserver' in window) new ResizeObserver(schedule).observe(header);
  schedule();
})();
